export default function validation(response, messages) {
  if (!response.data || !response.data.error || !response.data.error.validationErrors) {
    return;
  }
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message.indexOf('FORBIDDEN_CREATEORUPDATE_OD') === 0) {
      messages.push({
        message: 'addOperationDiverse.validation.forbiddenCreateOrUpdate',
      });
    }
    if (message.indexOf('FORBIDDEN_TO_UPDATE_LETTERED_CUSTOMER_TRANSACTION') === 0) {
      messages.push({
        message: 'addOperationDiverse.validation.forbiddenCreateOrUpdateLetteredTransaction',
      });
    }
    if (message.indexOf('UPDATE_FORBIDDEN_FOR_VALIDATED_STATE') === 0) {
      messages.push({
        message: 'addOperationDiverse.validation.forbiddenUpdateAtValidateState',
      });
    }
    if (message.indexOf('VALIDATION_FORBIDDEN_FOR_VALIDATED_STATE') === 0) {
      messages.push({
        message: 'detailOperationDiverse.validation.errors.forbiddenValidationAtValidateState',
      });
    }
    if (message.indexOf('INVALID_ECRITURE_COMTABLE') === 0) {
      messages.push({
        message: 'detailOperationDiverse.validation.errors.invalideEcritureComptable',
      });
    }
    if (message.indexOf('FORBIDDEN_DELETE_OD_AT_VALIDE_STATE') === 0) {
      const reference = message.split('|')[0].split('@')[1];
      messages.push({
        message: 'detailOperationDiverse.popUpSuppression.errors.forbidden_DeleteODIfAtValidateState',
        parametres: {
          reference: reference,
        },
      });
    }
    if (message.indexOf('FORBIDDEN_DELETE_MOUVEMENT_OD_LETTRE') === 0) {
      const libelle = message.split('|')[0].split('@')[1];
      messages.push({
        message: 'detailOperationDiverse.popUpSuppression.errors.forbidden_DeleteMouvementOdIfIsLettre',
        libelle: libelle,
      });
    }
  });
}
